import history from '../../../../utils/history';

export const addSubscriptionHandler = () => {
    history.push('/planSelector');
};


// WEBPACK FOOTER //
// ./src/containers/config/ConfigModals/mySubscriptions/handlers.js